export default __webpack_public_path__ + "static/Image 40-f66d5f4e7382b35ec6b7db2ce1251656.png";